import { FC, ReactElement } from "react";
import { Outlet } from "react-router-dom";
import { Paper, Box, Grid, Stack } from "@mui/material";

import { logo } from "@/constants";

const AuthLayout: FC = (): ReactElement => {
  return (
    <Grid container component="main" sx={{ height: "100dvh" }}>
      <Grid
        item
        xs={0}
        sm={0}
        md={0}
        lg={6}
        xl={6}
        sx={{ display: { lg: "block", xs: "none" } }}
      >
        <Box
          sx={{
            height: "100%",
            overflow: "hidden",
            background: "#f5f5f5",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: "110%",
              height: "100%",
              opacity: "20%",
              background: "#64E3E8",
              borderRadius: "50%",
              position: "absolute",
              top: "-20%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              filter: "blur(100px)",
            }}
          />
          <Box
            sx={{
              width: "110%",
              height: "100%",
              opacity: "20%",
              background: "#64E3E8",
              borderRadius: "50%",
              position: "absolute",
              top: "110%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              filter: "blur(100px)",
            }}
          />
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              width: "100%",
              maxWidth: "510px",
              mx: "auto",
              height: "100%",
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="bg-img"
              style={{
                objectFit: "contain",
                objectPosition: "center",
                width: "60%",
              }}
            />
          </Stack>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={6}
        xl={6}
        sx={{ boxShadow: "none", pr: 2 }}
        component={Paper}
      >
        <Outlet />
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
